import { tokenService } from '@/utils/request/service-with-token';
import { service } from '@/utils/request/service';
// 待办任务
export function waitTask(params) {
  return tokenService({
    url: '/WorkFlowModule/WfMyTask/GetTaskList',
    method: 'GET',
    params,
  });
}
// 已办任务
export function hasTask(params) {
  return tokenService({
    url: '/WorkFlowModule/WfDoneTask/GetTaskList',
    method: 'GET',
    params,
  });
}
// 归档任务
export function archivingTask(params) {
  return tokenService({
    url: '/WorkFlowModule/WfFinishProcess/GetFinishProcessList',
    method: 'GET',
    params,
  });
}
// 所有任务
export function allTasks(params) {
  return tokenService({
    url: '/WorkFlowModule/WfMultSearchTask/GetAllEquipment',
    method: 'GET',
    params,
  });
}
export function getTaskFormAndHistory(params) {
  return tokenService({
    url: '/WorkFlowModule/WorkFlow/ProcessinfoByMonitor',
    method: 'GET',
    params,
  });
}
// 获取运维队伍
export function getOperationTeams() {
  return tokenService({
    url: '/WorkFlowModule/QXGD/Get_RanksInfo_TreeSelectJson_New',
    method: 'GET',
  });
}
// 获取队伍成员
export function getTeamMembers(params) {
  return tokenService({
    url: '/SystemManage/User/GetListByOrganizeID',
    method: 'GET',
    params,
  });
}
// 获取下一步信息
export function getNextStepInfo(params) {
  return tokenService({
    url: '/WorkFlowModule/WorkFlow/GetAuditerSelectJson',
    method: 'GET',
    params,
  });
}
// 获取故障确认状态下拉框数据
export function queryxlk(params) {
  return tokenService({
    url: '/api/WF/v1/GetGuZhangQueRenDropList',
    method: 'GET',
    params,
  });
}
// 获取故障类型下拉数据
export function getOrderSelectorData(params) {
  return tokenService({
    url: 'api/APPAPI_NEW/v1/Get_WarningTypeTree',
    method: 'GET',
    params,
  });
}
// 提交审核表单
export function auditOrder(formData, params = {}) {
  return tokenService({
    url: '/WorkFlowModule/WorkFlow/Audit',
    method: 'POST',
    data: formData,
    params,
  });
}

// 上传图片
export function uploadImages(formData, params = {}) {
  return tokenService({
    url: '/WorkFlowModule/QXGD/SaveImagesList',
    method: 'POST',
    data: formData,
    params,
  });
}

// 创建新工单
export function createNewOrder(formData, params = {}) {
  return tokenService({
    url: '/WorkFlowModule/WorkFlow/Create',
    method: 'POST',
    data: formData,
    params,
  });
}

// 获取故障类型下拉数据
export function getSchemeCodeList(params) {
  return service({
    url: 'api/WF/v1/GetSchemeCodeList',
    method: 'GET',
    params,
  });
}

// 上传图片
export function uploadImagesGD(formData, params = {}) {
  return tokenService({
    url: '/WorkFlowModule/WorkFlow/GD_Upload',
    method: 'POST',
    data: formData,
    params,
  });
}
